import avatar from '../../../assets/avatar_tooltip.png'

const HeaderUserTooltip = () => {
  return (
    <div className="header-toolip_user">
      <img src={avatar} alt="Avatar" />
      <div>
        <p className="source-16 c-dark bold mb-5">Super Admin (Rol)</p>
        <p className="source-16 c-dark mb-5">Nombre del Usuario(a)</p>
        <p className="source-16 c-blue mb-5">nombre.apellido@dominiolargo.com</p>
      </div>
    </div>
  )
}

export default HeaderUserTooltip
